import { OpenInNew } from '@mui/icons-material';
import { Button, Tooltip } from '@mui/material';
import { hasVendorPortal, NEEDS_ORDER_ID_TOOLTIP, portalHref } from './constants';
import { orderIdValue, orderVendor, OrderFactSource } from './orderFacts';
import { rowLinkSx } from './rowLink';

const ViewInVendor = ({ align = 'start', source }: { align?: 'start' | 'end'; source: OrderFactSource }) => {
  const vendor = orderVendor(source);
  if (!hasVendorPortal(vendor)) return null;

  const href = portalHref(vendor, orderIdValue(source));
  const button = (
    <Button
      component={href ? 'a' : 'button'}
      disabled={!href}
      href={href || undefined}
      rel={href ? 'noopener noreferrer' : undefined}
      startIcon={<OpenInNew />}
      sx={rowLinkSx}
      target={href ? '_blank' : undefined}
    >
      View in Vendor
    </Button>
  );

  const control = href ? (
    button
  ) : (
    <Tooltip title={NEEDS_ORDER_ID_TOOLTIP}>
      <span>{button}</span>
    </Tooltip>
  );

  if (align === 'end') {
    return <div style={{ display: 'flex', justifyContent: 'flex-end' }}>{control}</div>;
  }

  return control;
};

export default ViewInVendor;
